export default "__VITE_ASSET__CyChLkqS__"